import PropTypes from "prop-types";
import React, { Component } from "react";
import { MenuButton } from "react-md";

class AppraiserFilterMenu extends Component {
  constructor() {
    super();
    this.state = {
      isMenuOpen: false
    };
    this.click = this.click.bind(this);
    this.arrToObj = this.arrToObj.bind(this);

    this.clickAppraiserId = this.clickAppraiserId.bind(this);
    this.toggle = this.toggle.bind(this);
    this.close = this.close.bind(this);
  }

  componentWillUnmount() {
    this.toggle = () => { };
  }


  //Stuff Shared with Insurance Filter Menu
  clickAppraiserId(e) {
    this.props.onChange({
      term: "appraiser",
      title: "Appraiser: " + e.currentTarget.innerText,
      code: "id",
      id: e.currentTarget.id
    });
    this.close();
  }

  arrToObj(item) {
    const obj = {onClick: this.click, primaryText: item};
    return obj;
  }
 /////////////////////////////////////////////

  toggle() {
    this.setState({ isMenuOpen: !this.state.isMenuOpen });
  }

  close() {
    this.toggle();
  }

  click(e) {
    this.props.onChange({
      term: "appraiser",
      title: e.currentTarget.innerText,
      code: e.currentTarget.id,
      id: ""
    });
    this.close();
  }

  render() {

    return (
      <MenuButton
      id="menu-button-3"
      position={MenuButton.Positions.BELOW}
      raised
      iconChildren="filter_list"
    >
      {this.props.title}
    </MenuButton>
    );
  }
}

AppraiserFilterMenu.propTypes = {
  onChange: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  items: PropTypes.array.isRequired,
  appraiserId: PropTypes.string,
  appraiserName: PropTypes.string
};

export default AppraiserFilterMenu;